import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import FolderPicker from "../folderPicker/FolderPicker";
import { IFolderPath } from "@shared/mirage/core/contracts/IFoldersService";

interface FolderCellProps extends GridRenderCellParams {
    onCellChanged: (id: number, field: string, value: string) => Promise<void>;
    folders: IFolderPath[];
    readOnly?: boolean;
}

const FolderCell: React.FC<FolderCellProps> = ({ onCellChanged, readOnly, folders, ...params }) => {
    const { id, field, value } = params;
    const onFolderChange = async (newValue: string) => {
        await onCellChanged(Number(id), field as string, newValue);
    };
    return <FolderPicker folders={folders} onFolderSelect={async (v) => await onFolderChange(v)} value={value} readOnly={readOnly} />;
};

export default FolderCell;
